import { render, staticRenderFns } from "./ExpressTemplateDetail.vue?vue&type=template&id=5861855a&scoped=true&"
import script from "./ExpressTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./ExpressTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExpressTemplateDetail.vue?vue&type=style&index=0&id=5861855a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861855a",
  null
  
)

export default component.exports